export const selectedOptions = {
  size: ["Taille", "Size"],
  color: ["Couleur", "Color"],
} as const
